import {AfterViewInit, Component, Input, OnDestroy, OnInit, ElementRef, Renderer2} from '@angular/core';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import {User} from '@models/user';
import {Program} from '@models/program';
import {CreateProgramSubscriptionComponent} from '@pages/layout/program/program-page/program-payment/create-program-subscription/create-program-subscription.component';
// import {CreatePaymentComponent} from '@pages/layout/payments/payments-page/payments-page.component';
import {MatDialog} from '@node_modules/@angular/material';
import {Subscription} from '@models/subscription';
import {ProgramService} from '@services/program/program.service';
import {UpdateAuthUser} from '@store/auth/actions';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {SubscriptionService} from '@services/subscription/subscription.service';
import {PaymentService} from '@services/payment/payment.service';
import {BehaviorSubject} from '@node_modules/rxjs/internal/BehaviorSubject';
import {Subject} from '@node_modules/rxjs/internal/Subject';
import {ProgramClassesComponent} from '@pages/layout/program/program-page/program-classes/program-classes.component';
import {CustomCarouselComponent} from '@components/custom-carousel/custom-carousel.component';
import * as ProgramReducer from '@store/program/reducers';
import {SetPrograms, UpdateProgram} from '@store/program/actions';
import * as SubscriptionReducer from '@store/subscription/reducers';
import {AttendanceService} from '@services/attendance/attendance.service';
import {TermsComponent} from '@components/terms/terms.component';
import {TermsPdfComponent} from '@components/terms-pdf/terms-pdf.component';
import {OnboardingRegisterComponent} from '@components/onboarding-register/onboarding-register.component';
import {ActivatedRoute, Router} from '@node_modules/@angular/router';
import {SchoolService} from '@services/school/school.service';
import {School} from '@models/shool';
import {environment} from '../../../../../environments/environment';
import {AddSubscriptionPageComponent} from '@pages/layout/subscription/add-subscription-page/add-subscription-page.component';
import {EditSubscriptionPageComponent} from '@pages/layout/subscription/edit-subscription-page/edit-subscription-page.component';

@Component({
  selector: 'app-admin-subscription-page',
  templateUrl: './admin-subscription-page.component.html',
  styleUrls: ['./admin-subscription-page.component.scss']
})
export class AdminSubscriptionPageComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() programs: Program[];
  @Input() user: User;
  @Input() usersSubject: Subject<User>;
  subscribes = [];
  moveSubscriptionCarousel: Subject<string> = new BehaviorSubject(null);
  refreshSubscriptionCarousel: Subject<string> = new BehaviorSubject(null);
  refreshPayments: Subject<string> = new BehaviorSubject(null);
  subscriptions: {
      name: string;
      description: string;
      payment_price: number;
      frequency_amount: number;
      frequency_name: string;
  }[] = [];
  subscriptionsFilter: any[];
  subscriptionsFilterDefault: any[];
  usersActivesubscriptionsIds = [];
  usersNotApprovedSubscriptionsIds = [];
  usersStoppedsubscriptionsIds = [];
  viewDialog;
  confirmStopDialog;
  confirmSubscribeDialog;
  confirmDialog;
  createDialog;
  editDialog;
  current_school;
  isDarkTheme = false;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private programService: ProgramService,
    private paymentService: PaymentService,
    private subscriptionService: SubscriptionService,
    private authStore: Store<AuthReducer.AuthState>,
    private programStore: Store<ProgramReducer.ProgramState>,
    private subscribtionStore: Store<SubscriptionReducer.SubscriptionState>,
    private schoolService: SchoolService,
    // private customCarouselComponent: CustomCarouselComponent,
  ) {

  }

  ngOnInit() {
    this.isDarkTheme = localStorage.getItem('mkc-dashboard-theme') === 'dark';
    this.applyTheme();

    this.loadSubscriptions();

  }

  ngOnDestroy() {
    this.subscribes.map( subscr => subscr.unsubscribe());
  }

  openCreateModalAction(){
    this.lockModalPageScroll();
    this.createDialog = this.dialog.open(AddSubscriptionPageComponent, {
      disableClose: true,
      autoFocus: false,
      panelClass: 'mkc-subscription-create-dialog',
    });
    this.createDialog.afterClosed().subscribe(() => {
      this.unlockModalPageScroll();
      this.loadSubscriptions();
    });
  }

  openViewModal(event, subscription: Subscription) {
    if (!event.target.classList.contains('buttons-bottom-continue')) {
      CreateProgramSubscriptionComponent.allSubscriptions = [];
      CreateProgramSubscriptionComponent.source = 'view';
      CreateProgramSubscriptionComponent.sourceEdit = subscription;
      this.viewDialog = this.dialog.open(CreateProgramSubscriptionComponent);
      CreateProgramSubscriptionComponent.modalRef = this.viewDialog;
      this.viewDialog.afterClosed().subscribe(result => {
        this.viewDialog.close();
      });
    }
  }

  tabber(e) {
    const index = Array.from(e.target.parentElement.children).indexOf(e.target);
    const elements = document.querySelectorAll('.item-content');
    document.querySelector('h2.active').classList.remove('active');
    e.target.classList.add('active');
    for (let i = 0; i < elements.length; i++) {
      if (index === i) {
        elements[i].classList.remove('hidden');
      } else {
        elements[i].classList.add('hidden');
      }
    }
  }

  ngAfterViewInit() {

  }

  openDeleteModal(sub) {
    ConfirmModalComponent.insertedObject = this;
    ConfirmModalComponent.textModal = 'Are you sure that you want to delete this Subsscription ?';
    ConfirmModalComponent.methodDelete = 'actionDelete';
    ConfirmModalComponent.methodDeleteParam = sub;
    this.confirmDialog = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.confirmDialog;
    this.confirmDialog.afterClosed().subscribe(result => {
      this.confirmDialog.close();
    });
  }

  actionDelete(sub) {
    this.subscriptionService.removeSub({id: sub.id}).subscribe(
      (resp: {data: any}) => {
        this.subscriptionService.getAllSub().subscribe(
          (resp: {data: any}) => {
            console.log(resp);
            this.subscriptions = resp.data;

          }
        );
      }

    );
  }

  openEdit(member){
    this.lockModalPageScroll();
    this.editDialog = this.dialog.open(EditSubscriptionPageComponent, {
      disableClose: true,
      autoFocus: false,
      panelClass: 'mkc-subscription-edit-dialog',
      data: {
        subId: member.id
      }
    });
    this.editDialog.afterClosed().subscribe(result => {
      this.unlockModalPageScroll();
      if (result) {
        this.loadSubscriptions();
      }
    });
  }

  handleCopyOnboardingLink(subscriptionId) {
    const onboardingLink = `${environment.STRIPE_BACK_URL}/auth/school/register?subId=${subscriptionId}`;
    const clipboardEventListener = (e: ClipboardEvent) => {
      e.preventDefault();
      e.clipboardData.setData("text", onboardingLink);
    };

    document.addEventListener("copy", clipboardEventListener)
    document.execCommand("copy");
  }

  parseIntervalType(interval, value = 1) {
    return value > 1 ? interval + 's' : interval;
  }

  openTermsDialog(subscription: Subscription) {
    const reference = this.dialog.open(TermsPdfComponent);
    reference.componentInstance.terms_pdf = subscription.terms_and_conditionals_link;
    TermsPdfComponent.modalRef = reference;
  }

  setTheme(theme: 'light' | 'dark') {
    this.isDarkTheme = theme === 'dark';
    localStorage.setItem('mkc-dashboard-theme', theme);
    this.applyTheme();
  }

  private applyTheme() {
    const shell = document.getElementById('page-wrapper');
    if (shell) {
      shell.classList.toggle('theme-dark', this.isDarkTheme);
    }
    document.documentElement.classList.add('mkc-dashboard-shell');
    document.body.classList.add('mkc-dashboard-shell');
    document.documentElement.classList.toggle('mkc-theme-dark', this.isDarkTheme);
    document.body.classList.toggle('mkc-theme-dark', this.isDarkTheme);
  }

  private lockModalPageScroll() {
    document.documentElement.classList.add('mkc-super-admin-modal-scroll-lock');
    document.body.classList.add('mkc-super-admin-modal-scroll-lock');
  }

  private unlockModalPageScroll() {
    document.documentElement.classList.remove('mkc-super-admin-modal-scroll-lock');
    document.body.classList.remove('mkc-super-admin-modal-scroll-lock');
  }

  private loadSubscriptions() {
    this.subscriptionService.getAllSub().subscribe(
      (resp: {data: any}) => {
        this.subscriptions = resp.data;
      }
    );
  }
}
